import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import { TIMEZONE_OPTIONS } from '@navstation-portal/shared/util/time';
import { LatLongComponent } from '@navstation-portal/shared/ui/components';
import {
  AbstractStoreConnectedSectionComponent,
  offshorePositionAndWeatherEvents,
  OffshorePositionAndWeatherFormStore,
  OffshoreReportStore,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-ship-position',
  templateUrl: './ship-position.component.html',
  imports: [FormsModule, LatLongComponent],
})
export class ShipPositionComponent extends AbstractStoreConnectedSectionComponent {
  timezoneOptions = TIMEZONE_OPTIONS;
  tabId = 'positionAndWeather';
  sectionId = 'shipPosition';
  events = injectDispatch(offshorePositionAndWeatherEvents);
  positionAndWeatherStore = inject(OffshorePositionAndWeatherFormStore);
  offshoreReportStore = inject(OffshoreReportStore);
}
